import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { SavingsProvider } from '../../contexts/SavingsContext';
import { MerchantProvider } from '../../contexts/MerchantContext';
import { SupportProvider } from '../../contexts/SupportContext';
import { AdvancedProvider } from '../../contexts/AdvancedContext';
import { CredioProvider } from '../../contexts/CredioContext';
import { SchoolProvider } from '../../contexts/SchoolContext';
import { DinepointProvider } from '../../contexts/DinepointContext';
import TransactionTab from '../credio/transactionTabs/transactions';
const PointerView = Loadable(lazy(() => import('../Dinepoint/points/statistic')));
const AnalyticInventory = Loadable(lazy(() => import('../inventory')));
const AnalyticMerchant = Loadable(lazy(() => import('../merchant')));
const AnalyticCredio = Loadable(lazy(() => import('../credio')));
const AnalyticSchool = Loadable(lazy(() => import('../School')));
const AnvancedView = Loadable(lazy(() => import('../advanced')));

const AddReader = Loadable(lazy(() => import('../../views/material-kit/forms/addNewReader')));

const AppTable = Loadable(lazy(() => import('./tables/AppTable')));
const AppForm = Loadable(lazy(() => import('./forms/AppForm')));
const AppButton = Loadable(lazy(() => import('./buttons/AppButton')));
const AppIcon = Loadable(lazy(() => import('./icons/AppIcon')));
const AppProgress = Loadable(lazy(() => import('./AppProgress')));
const AppMenu = Loadable(lazy(() => import('./menu/AppMenu'))); //'../Savings'
const SavingsAnalytics = Loadable(lazy(() => import('../Savings'))); //''
const SupportAnalytics = Loadable(lazy(() => import('../Support'))); //''
const SavingsTableAnalytics = Loadable(lazy(() => import('./tables/savingsTable'))); //''
const MerchantTableAnalytics = Loadable(lazy(() => import('./tables/merchantTable'))); //''
const CredioTableAnalytics = Loadable(lazy(() => import('./tables/credioTable'))); //'' SchholTableAnalytics
const SchholTableAnalytics = Loadable(lazy(() => import('./tables/schoolTable'))); //'' 
const CredioTableTransactionAnalytics = Loadable(lazy(() => import('./tables/credioTransactionTable'))); //''
const CredioTableReadersAnalytics = Loadable(lazy(() => import('./tables/readersTable'))); //''
const SavingsTablePumpsAnalytics = Loadable(lazy(() => import('./tables/pumpTable'))); //''
const CredioSavingsTableTransactionAnalytics = Loadable(lazy(() => import('./tables/credioSavingsTransactionTable'))); //''
const VasTableTransactionAnalytics = Loadable(lazy(() => import('./tables/vasTransactionTable'))); //''
const CoralVasTableTransactionAnalytics = Loadable(lazy(() => import('./tables/coralVasTransactionTable'))); //''
const SavingsTableTransactionAnalytics = Loadable(lazy(() => import('./tables/savingsTransactionTable'))); //''
const SellTableAnalytics = Loadable(lazy(() => import('./tables/sellsTable'))); //''
const AccountBalanceDataGrid = Loadable(lazy(() => import('./../credio/balance/account_balance'))); //''
const Accounting = Loadable(lazy(() => import('./../credio/account/accounting'))); //''
const CredioUserAnalytics = Loadable(lazy(() => import('../../views/credio/user'))); //''
const SavingUserAnalytics = Loadable(lazy(() => import('../../views/savings/user'))); //''
const SavingTransTypeAnalytics = Loadable(lazy(() => import('../../views/material-kit/tables/savingsTransTransactionTable'))); //''
const AppCheckbox = Loadable(lazy(() => import('./checkbox/AppCheckbox')));
const AppSwitch = Loadable(lazy(() => import('./switch/AppSwitch')));
const AppRadio = Loadable(lazy(() => import('./radio/AppRadio')));
const AppSlider = Loadable(lazy(() => import('./slider/AppSlider')));
const AppDialog = Loadable(lazy(() => import('./dialog/AppDialog')));
const AppSnackbar = Loadable(lazy(() => import('./snackbar/AppSnackbar')));
const AppAutoComplete = Loadable(lazy(() => import('./auto-complete/AppAutoComplete')));
const AppExpansionPanel = Loadable(lazy(() => import('./expansion-panel/AppExpansionPanel')));
const AllUserTable = Loadable(lazy(() => import('./tables/allUserTable')));

const Mobilizers = Loadable(lazy(() => import('../Mobilizers/index')));
const CreateMobilizer = Loadable(lazy(() => import('../Mobilizers/create-level-1/index')));
const Dinepoint = Loadable(lazy(() => import('../Dinepoint/index')));
const TransactionsDashboard = Loadable(lazy(() => import('../Dinepoint/TransactionsDashboard')));
const OrdersDashboard = Loadable(lazy(() => import('../Dinepoint/OrdersDashboard')));
const PointersDashboard = Loadable(lazy(() => import('../Dinepoint/PointerDashboard')));
const materialRoutes = [
  {
    path: '/new/users',
    element: <AppTable />,
  },
  {
    path: '/all/users',
    element: <AllUserTable />,
  },
  {
    path: '/material/form',
    element: <AppForm />,
  },
  {
    path: '/analytics/inventory',
    element: <AnalyticInventory />,
  },
  {
    path: '/analytics/mobilizers',
    element: <Mobilizers />,
  },

  {
    path: '/analytics/credio/account-balances',
    element: <AccountBalanceDataGrid />,
  },

    {
    path: '/analytics/credio/accounting',
    element: <Accounting />,
  },


  {
    path: '/analytics/mobilizers/create-level-1',
    element: <CreateMobilizer />,
  },

  {
    path: '/tools/dinepoint',
    element: <DinepointProvider> <Dinepoint /></DinepointProvider>,
  }
  ,
  {
    path: '/tools/dinepoint/transactions',
    element: <DinepointProvider> <TransactionsDashboard /></DinepointProvider>,
  },
  {
    path: '/tools/dinepoint/orders',
    element: <DinepointProvider> <OrdersDashboard /></DinepointProvider>,
  },
  {
    path: '/tools/dinepoint/pointers',
    element: <DinepointProvider> <PointersDashboard /></DinepointProvider>,
  },

  {
    path: '/tools/dinepoint/pointer/:id',
    element: <DinepointProvider> <PointerView /></DinepointProvider>,
  },

  {
    path: '/analytics/merchant/reader/add',
    element: (
      <MerchantProvider>
        <AddReader />
      </MerchantProvider>
    ),
  },
  {
    path: '/analytics/credio',
    element: (
      <CredioProvider>
        <AnalyticCredio />
      </CredioProvider>
    ),
  },


  {
    path: '/analytics/school',
    element: (
      <SchoolProvider>
        <AnalyticSchool />
      </SchoolProvider>
    ),
  },

  {
    path: '/analytics/schools/table/:type',
    element: (
      <SchoolProvider>
        <SchholTableAnalytics />
      </SchoolProvider>
    ),
  },
  {
    path: '/analytics/credio/table/:type/:phoneNumber',

    element: (
      <CredioProvider>
        <CredioTableAnalytics />
      </CredioProvider>
    ),
  },
  {
    path: '/analytics/credio/transaction/:type',

    element: (
      <CredioProvider>
        <TransactionTab />
      </CredioProvider>
    ),
  },

  {
    path: '/analytics/credio/readers',

    element: (
      <CredioProvider>
        <CredioTableReadersAnalytics />
      </CredioProvider>
    ),
  },
  {
    path: '/analytics/credio/vas/coralPay',

    element: (
      <CredioProvider>
        <CoralVasTableTransactionAnalytics />
      </CredioProvider>
    ),
  },

  {
    path: '/analytics/credio/vas/shm',

    element: (
      <CredioProvider>
        <VasTableTransactionAnalytics />
      </CredioProvider>
    ),
  },

  {
    path: '/analytics/credio/savings',

    element: (
      <CredioProvider>
        <CredioSavingsTableTransactionAnalytics />
      </CredioProvider>
    ),
  },
  {
    path: '/analytics/savings/:user/:phoneNumber',

    element: (
      <SavingsProvider>
        <SavingsTableTransactionAnalytics />
      </SavingsProvider>
    ),
  },


  {
    path: '/analytics/savings/pumps/:type',

    element: (
      <SavingsProvider>
        <SavingsTablePumpsAnalytics />
      </SavingsProvider>
    ),
  },

  {
    path: '/analytics/credio/user/:phoneNumber',

    element: (
      <CredioProvider>
        <CredioUserAnalytics />
      </CredioProvider>
    ),
  },
  {
    path: '/analytics/savings/agent/:type/:phoneNumber',

    element: (
      <SavingsProvider>
        <SavingTransTypeAnalytics />
      </SavingsProvider>
    ),
  },
  {
    path: '/analytics/savings/user/details/:phoneNumber',

    element: (
      <SavingsProvider>
        <SavingUserAnalytics />
      </SavingsProvider>
    ),
  },
  {
    path: '/analytics/credio/table/:type',

    element: (
      <CredioProvider>
        <CredioTableAnalytics />
      </CredioProvider>
    ),
  },
  {
    path: '/analytics/sells/table/:type',

    element: (
      <SupportProvider>
        <SellTableAnalytics />
      </SupportProvider>
    ),
  },

  {
    path: '/tools/advance',

    element: (
      <AdvancedProvider>
        <AnvancedView />
      </AdvancedProvider>
    ),
  },
  {
    path: '/analytics/savings',

    element: (
      <SavingsProvider>
        <SavingsAnalytics />
      </SavingsProvider>
    ),
  },
  {
    path: '/analytics/sells',

    element: (
      <SupportProvider>
        <SupportAnalytics />
      </SupportProvider>
    ),
  },
  {
    path: '/analytics/savings/table/:type/:phoneNumber',

    element: (
      <SavingsProvider>
        <SavingsTableAnalytics />
      </SavingsProvider>
    ),
  },
  {
    path: '/analytics/savings/table/:type',

    element: (
      <SavingsProvider>
        <SavingsTableAnalytics />
      </SavingsProvider>
    ),
  },
  {
    path: '/analytics/merchant/table/:type',

    element: (
      <CredioProvider>
        <MerchantTableAnalytics />
      </CredioProvider>
    ),
  },
  {
    path: '/material/buttons',
    element: <AppButton />,
  },
  {
    path: '/material/icons',
    element: <AppIcon />,
  },
  {
    path: '/material/progress',
    element: <AppProgress />,
  },
  {
    path: '/material/menu',
    element: <AppMenu />,
  },
  {
    path: '/material/checkbox',
    element: <AppCheckbox />,
  },
  {
    path: '/material/switch',
    element: <AppSwitch />,
  },
  {
    path: '/material/radio',
    element: <AppRadio />,
  },
  {
    path: '/material/slider',
    element: <AppSlider />,
  },
  {
    path: '/material/autocomplete',
    element: <AppAutoComplete />,
  },
  {
    path: '/material/expansion-panel',
    element: <AppExpansionPanel />,
  },
  {
    path: '/material/dialog',
    element: <AppDialog />,
  },
  {
    path: '/material/snackbar',
    element: <AppSnackbar />,
  },
];

export default materialRoutes;
